import CheckCam from '@/views/Check/CheckCam'

const routes = {
  path: '/check_cam',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/check_cam',
      name: 'Marcar Ponto',
      component: CheckCam,
    },
  ],
}

export default routes
